import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Input, Popconfirm, Row, Switch } from 'antd'

import {
  FormItemList,
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

import { recordError } from '../../../utils/logService';
import service from '../../../services/systemConfigService';

export default function SystemConfig() {

    const [disabled, setDisabled] = useState(true);
    const [isDisabled, setIsDisabled] = useState(true);
    const [buttonTitle, setButtonTitle] = useState("Enable");
    const [validateWhiteList, setValidateWhiteList] = useState(true);
    const [configData, setConfigData] = useState({});

    useEffect(() => {
        getConfigurations();
    }, [])


    const formItemLayout = {
        labelCol: {
            xs: {
                span: 12,
            },
            sm: {
                span: 8,
            },
        },
        wrapperCol: {
            xs: {
                span: 12,
            },
            sm: {
                span: 8,
            },
        },
    };

    const [form] = Form.useForm();
    const formName = "SystemConfig";

    let msg = "";

    const mainTitle = "System Configuration";

    const getConfigurations = async () => {
        try {
            const response = await service.getConfigs();

            if (response && response.status === 200) {
                const { data } = response;
                onFormLoad(data);
                setConfigData(data);
            } else {
                onFormLoad();
            }
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE, "System configurations");
            openNotification("System configs retrival", msg, Notify.ERROR);
            recordError(error);
        }
    };
    const submitValues = async (values) => {

        try {
            const request = await service.updateConfigs(values)

            if (request.status == 200 || request.status == 201) {
                msg = util.parseMessage(Messages.ADD_SUCCESS, "System configurations");
                openNotification("Configurations save", msg, Notify.SUCCESS);
                onFormLoad(values);
                setConfigData(values);
                return;
            }
        } catch (error) {
            msg = util.parseMessage(Messages.ADD_FAILURE, "System configuration");
            openNotification("System configs save", msg, Notify.ERROR);
            recordError(error);
        }
    };
    const confirmCancel = () => {

        onFormLoad(configData)
        handleEditing();
        setDisabled(true);
    };
    const handleCancel = () => {

        if (form.getFieldValue("stemiRecordLimit") || form.getFieldValue("nysHostLinkExpiry") || form.getFieldValue("emailDomainWhitelist") || form.getFieldValue("validateWhitelist")) {
            setDisabled(false);
        }
    };
    const handleChange = (e) => {
        const value1 = e.target.value;
        const value2 = e.target.value;

        if (value1.length && value2.length > 0) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    };
    const onFormLoad = (data) => {

        if (!util.isEmpty(data)) {
            form.setFieldsValue({

                id: data.id,
                stemiRecordLimit: data.stemiRecordLimit,
                emailDomainWhitelist: data.emailDomainWhitelist,
                validateWhiteList: data.validateWhiteList,
                adminEmailAddress: data.adminEmailAddress,
                notifyNysRejection: data.notifyNysRejection,
                helpdeskEmailAddress: data.helpdeskEmailAddress,
                nysHostLinkExpiry: data.nysHostLinkExpiry
            })
        }
    }
    const handleEditing = () => {
        setIsDisabled(!isDisabled);
        setButtonTitle(!buttonTitle);
    };

    return (
      <>
        <div className="content" key={"main-div"}>
          <Col xs={24}>
            <h1 className="center-align">{mainTitle}</h1>
          </Col>
          <Row>
            <Col xs={24} className="right-align">
              <Button
                key="1"
                type="primary"
                className="center-align"
                onClick={handleEditing}
              >
                {buttonTitle ? "Enable" + " Editing" : "Disable" + " Editing"}
              </Button>
            </Col>
          </Row>
          <br></br>
          <Form
            {...formItemLayout}
            form={form}
            name={formName}
            onFinish={submitValues}
            disabled={isDisabled}
          >
            <Card>
              <Form.Item hidden={true} name="id" label="id">
                <Input name="id" />
              </Form.Item>
              <Form.Item
                name="stemiRecordLimit"
                label="Uploads Record Limit: "
                rules={[
                  {
                    pattern: new RegExp("^[0-9]*$"),
                    message: "Only numbers allowed in this field.",
                  },
                  {
                    required: true,
                    message: "Please provide stemi record number.",
                  },
                ]}
              >
                <Input
                  name="stemiRecordLimit"
                  value={isDisabled}
                  onChange={handleChange}
                />
              </Form.Item>
               <Form.Item
                name="nysHostLinkExpiry"
                label="NYS Host Link Expiry (days): "
                rules={[
                  {
                    pattern: new RegExp("^[0-9]*$"),
                    message: "Only numbers allowed in this field.",
                  },
                  {
                    required: true,
                    message: "Please provide key expiry time.",
                  },
                ]}
              >
                <Input
                  name="nysHostLinkExpiry"
                  value={isDisabled}
                  onChange={handleChange}
                />
              </Form.Item>
              <Form.Item
                name="emailDomainWhitelist"
                label="Email Domain Whitelist"
                rules={[
                  {
                    required: true,
                    message: "Please provide Email Domain Whitelist",
                  },
                ]}
              >
                <FormItemList
                  name={"emailDomainWhitelist"}
                  value={isDisabled}
                  buttonLabel={"Add Email Domain Whitelist"}
                  placeholder="Email Domain Whitelist"
                  // onchange={handleChange}
                  disabled={isDisabled}
                />
              </Form.Item>
              <Form.Item
                name="adminEmailAddress"
                label="Admin Email Address"
                rules={[
                  {
                    type: "email",
                    message: "Email address is not valid!",
                  },
                  {
                    required: true,
                    message: "Please input Administrator Email Address!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="helpdeskEmailAddress"
                label="Helpdesk Email Address"
                rules={[
                  {
                    type: "email",
                    message: "Email address is not valid!",
                  },
                  {
                    required: true,
                    message: "Please input Helpdesk Email Address!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Validate Whitelist?"
                name="validateWhitelist"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={"Yes"}
                  unCheckedChildren={"No"}
                />
              </Form.Item>
              <Form.Item
                label="Notify NYS Rejections?"
                name="notifyNysRejection"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={"Yes"}
                  unCheckedChildren={"No"}
                />
              </Form.Item>
              <Row>
                <Col xs={24} className="center-align">
                  <Button
                    key="dd-btn-2"
                    type="primary"
                    htmlType="submit"
                    form={formName}
                    style={{ marginLeft: 10 }}
                  >
                    Save
                  </Button>
                  <Popconfirm
                    key="dd-pop-1"
                    title="Are you sure you want to cancel...you will lose all info entered?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => confirmCancel()}
                    onCancel={() => handleCancel()}
                    disabled={disabled}
                  >
                    <Button
                      onMouseUp={() => handleCancel()}
                      style={{ marginLeft: 10 }}
                    >
                      Cancel
                    </Button>
                  </Popconfirm>
                </Col>
              </Row>
            </Card>
          </Form>
        </div>
      </>
    );
}